<div class="home">
  <div class="body">
    <img src="/assets/images/anper/anper-logo.jpg" width="320px" height="auto">
    <div class="help-banner">
      <h4>{{'home.questions-1'|translate}}</h4>
      <p>{{'home.questions-2'|translate}}</p>
    </div>
  </div>
</div>
